import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './config/i18n.js';

import store from 'redux/store/store';
import { Provider } from 'react-redux';
import AuthService from 'services/AuthService';
import ErrorPage from 'pages/ErrorPage/ErrorPage';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CircularProgress, Box } from '@mui/material';

const queryClient = new QueryClient();

const LoadingFallback = () => (
  <Box display='flex' justifyContent='center' alignItems='center' minHeight='100vh'>
    <CircularProgress />
  </Box>
);

const renderApp = () =>
  ReactDOM.render(
    <StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <Suspense fallback={<LoadingFallback />}>
              <App />
            </Suspense>
          </Provider>
        </QueryClientProvider>
      </BrowserRouter>
    </StrictMode>,
    document.getElementById('root')
  );

const renderError = () =>
  ReactDOM.render(
    <StrictMode>
      {' '}
      <Provider store={store}>
        <ErrorPage
          errorCode={500}
          errorText={'Az authentikációs szerver jelenleg nem elérhető. Kérjük próbálja újra később!'}
        />
      </Provider>{' '}
    </StrictMode>,
    document.getElementById('root')
  );

AuthService.initKeyCloak(renderApp, renderError);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
